module.exports = __webpack_public_path__ + "img/img-1.a125c784.png";